module.exports = __webpack_public_path__ + "img/title.46e4c38a.png";